import { toast, ToastOptions } from 'react-toastify';

const defaultOptions: ToastOptions = {
    className: 'app-toast',
    autoClose: 5000,
    position: "bottom-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    theme: "light",
};

const Toaster = {
    success: (message: string, config?: ToastOptions) =>
        toast.success(message, { ...defaultOptions, className: `${defaultOptions.className} app-toast-success`, ...config }),

    error: (message: string, config?: ToastOptions) =>
        toast.error(message, { ...defaultOptions, className: `${defaultOptions.className} app-toast-error`, ...config }),

    info: (message: string, config?: ToastOptions) =>
        toast.info(message, { ...defaultOptions, className: `${defaultOptions.className} app-toast-info`, ...config }),

    warn: (message: string, config?: ToastOptions) =>
        toast.warn(message, { ...defaultOptions, className: `${defaultOptions.className} app-toast-warn`, ...config }),
};

export default Toaster;
